import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

const BankAccountsDetailsPage = () => {
  const history = useHistory();
  const match = useRouteMatch<{ bankAccountId: string }>();

  useEffect(() => {
    if (match.isExact) {
      history.replace(
        `/app/financial/accounts/bankAccounts/${match.params.bankAccountId}/general`,
      );
    }
  }, [match]);

  return null;
};

export default BankAccountsDetailsPage;
